import { useField } from 'formik';

export const Input: React.FC<{ label: string } & any> = ({
  label,
  ...props
}) => {
  const [field, meta] = useField(props);
  return (
    <>
      <div className="p-accountForm__item">
        <div className="p-accountForm__itemTitle">
          <span className="is-required">{label}</span>
        </div>
        <div className="p-accountForm__itemContent">
          <input data-formrun-required {...field} {...props} />
          {meta.touched && meta.error ? (
            <div className="error">{meta.error}</div>
          ) : null}
        </div>
      </div>
    </>
  );
};
